import Axios from 'axios';

const name = "hibp";
const version = "0.0.0-semantically-released";

/**
 * An Axios instance used for API queries. Not meant for general use.
 *
 * @internal
 * @private
 */
var axios = Axios.create({
    baseURL: 'https://haveibeenpwned.com/api',
    headers: Object.assign({
        Accept: 'application/vnd.haveibeenpwned.v2+json'
    }, typeof navigator === 'undefined' ? {
        // Add a custom User-Agent header when running outside the browser
        'User-Agent': "".concat(name, " ").concat(version)
    } : {})
});

export default axios;
//# sourceMappingURL=axiosInstance.js.map



//////////////////
// WEBPACK FOOTER
// ./~/hibp/es/axiosInstance.js
// module id = ./node_modules/hibp/es/axiosInstance.js
// module chunks = 2